import { useGetCandidateReviews } from '@entities/candidateReview';
import { PaginateType } from '@shared/types';
import { ReviewsPreview } from '@shared/ui';
import { CandidateReviewCard } from './CandidateReviewCard';

type CandidateReviewsProps = {
  candidateId: number;
};

const PREVIEW_COUNT = 3;

export const CandidateReviews = ({ candidateId }: CandidateReviewsProps) => {
  const { data, isLoading } = useGetCandidateReviews(
    {
      filter: {
        candidateId: { items: [candidateId], operator: 'or' },
      },
      sort: {
        reviewAt: 'desc',
      },
      paginate: PaginateType.DEFAULT,
      perPage: PREVIEW_COUNT,
    },
    Boolean(candidateId)
  );

  return (
    <ReviewsPreview
      data={data}
      isLoading={isLoading}
      previewCount={PREVIEW_COUNT}
      viewAllHref={`/reviews?tab=company-reviews&candidateId=${candidateId}`}
      renderCard={review => <CandidateReviewCard review={review} />}
    />
  );
};
